__turbopack_context__.v({
  "banner": "DownloadApps-module-scss-module__YgehaW__banner",
  "container": "DownloadApps-module-scss-module__YgehaW__container",
  "image": "DownloadApps-module-scss-module__YgehaW__image",
  "images": "DownloadApps-module-scss-module__YgehaW__images",
  "links": "DownloadApps-module-scss-module__YgehaW__links",
  "subHeader": "DownloadApps-module-scss-module__YgehaW__subHeader",
});
